import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24b3b8ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3b8ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b3b8ca')) {
      api.createRecord('24b3b8ca', component.options)
    } else {
      api.reload('24b3b8ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=24b3b8ca&scoped=true", function () {
      api.rerender('24b3b8ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/SearchPage/index.vue"
export default component.exports